import { BetterComboBoxItemFilterFunction } from "../utils/ComboBoxFilterUtil";
import ManyOptionsMultiComboBox from "./ManyOptionsMultiComboBox";

/**
 * Implements "Contains" filtering, including additional text for items
 * @namespace akademika.akamont.customControls
 */
export default class MultiComboBoxBetterFilter extends ManyOptionsMultiComboBox {
  init(): void {
    super.init.apply(this);

    this.setFilterFunction(BetterComboBoxItemFilterFunction);
  }

  static renderer = { apiVersion: 2 };
}
